// extracted by mini-css-extract-plugin
module.exports = {"Logo":"SVGLogo_Logo__1lVGR"};